import { generateBrandInternalUri } from '@search/core/hooks/useApis/generateBrandUri';
import { fetchSeoProps } from '../../services/seoProps/fetchSeoProps';
import { createLogger } from '../createLogger';
import { filterSeoQueryStringParams } from '../filterSeoQueryStringParams';
const extractUserIp = (xForwardedFor) => {
    if (!xForwardedFor) {
        return undefined;
    }
    if (Array.isArray(xForwardedFor))
        return xForwardedFor[0];
    return xForwardedFor.split(',')[0];
};
const getUserId = (searchParams, getHeader) => {
    const userId = searchParams.has('fakeUser')
        ? decodeURIComponent(searchParams.get('fakeUser') ?? '')
        : extractUserIp(getHeader('x-forwarded-for'));
    return userId;
};
const getSeoProps = async (searchParams) => {
    if (!searchParams.has('seoPath'))
        return undefined;
    const seoPath = decodeURIComponent(searchParams.get('seoPath') ?? '');
    const seoQueryString = decodeURIComponent(searchParams.get('seoQueryString') ?? '');
    /*
    Doing this to handle SEO links mixing path & query string
    ex: https://dev.immowelt.de/suche/berlin/wohnungen/kaufen?roomi=4&rooma=4
    the lambda@edge calls our app by providing separate qs params:
      1. seoPath -> https://dev.immowelt.de/suche/berlin/wohnungen/kaufen
      2. seoQueryString -> roomi=4&rooma=4
    this was done to avoid confusion in querystring parameters on our side (searchParams mixing seoPath & the actual seo qs params)
    */
    const filteredSeoQueryString = filterSeoQueryStringParams(seoQueryString);
    const seoReconstructedLink = `${seoPath}${filteredSeoQueryString ? '?' : ''}${filteredSeoQueryString}`;
    const brand = process.env.BRAND_ID;
    const stage = process.env.STAGE;
    const bffUri = generateBrandInternalUri({ brand, stage });
    // FIXME: find a way to handle locale in this function
    const seoProps = await fetchSeoProps(seoReconstructedLink, 'de', bffUri);
    return seoProps;
};
export const handleServerRequest = async (request, response) => {
    const logger = createLogger('app_serp');
    const { searchParams } = request.url;
    const userId = getUserId(searchParams, request.getHeader);
    try {
        const seoProps = await getSeoProps(searchParams);
        if (seoProps) {
            if ('gone' in seoProps && seoProps.gone) {
                response.notFound(410);
            }
            if ('permanentRedirect' in seoProps) {
                response.redirect(seoProps.permanentRedirect, 301);
            }
            return {
                data: {
                    seoProps,
                    userId,
                },
            };
        }
    }
    catch (error) {
        logger.warn(`[SERP createApplication] Error while fetching seoProps with searchParams=${searchParams}`);
    }
    return {
        data: {
            seoProps: undefined,
            userId,
        },
    };
};
